import {UseCase} from '../../base/use-case';
import {ErrorModel} from '../../models/shared/error-model';
import {Observable} from 'rxjs';
import {ConfigurationGateway} from '../../gateways/api-services/configuration-gateway';

export class GetAppVersionUseCase implements UseCase<null, string | ErrorModel> {
  constructor(private configurationGateway: ConfigurationGateway) {}
  execute(param: null): Observable<string | ErrorModel> {
    return this.configurationGateway.getAppVersion();
  }
}
